<template>
  <v-container id="ur-list">
    <v-row>
      <v-col>Instituições</v-col>

      <v-col class="text-right">
        <app-modal-insert-ur
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadUrs"
        >
          <template v-slot:title :edit="false">
            Cadastrar Instituição
          </template>
        </app-modal-insert-ur>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <combobox-municipio
          :multiple="true"
          :filter="payload"
          @onChange="(e) => (municipios = e)"
        ></combobox-municipio>
      </v-col>
      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="loadUrs()">
          <span>Filtrar</span>
        </v-btn></v-col
      >
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.categoria="{ item }">
            <div v-if="item.categoria.length > 0">
              <span v-for="(cat, index) in item.categoria" :key="index">
                {{ cat && cat.categoriaInstituicaoNome }}
                <span v-if="item.categoria.length > index + 1">, </span>
              </span>
            </div>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row
              v-if="
                isFullAdmin ||
                (config.permiteEditarInstituicao &&
                  groupsConfig.permiteEditarInstituicao)
              "
            >
              <v-col cols="1">
                <app-modal-insert-ur
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadUrs"
                >
                  <template v-slot:title> Editar Instituição </template>
                </app-modal-insert-ur>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row
              v-if="
                isFullAdmin ||
                (config.permiteDeletarInstituicao &&
                  groupsConfig.permiteDeletarInstituicao)
              "
            >
              <v-col cols="1">
                <app-modal-delete :object="item" @on-save="loadUrs">
                  <template v-slot:title> Deletar Instituição </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhuma Instituição retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertUr from "./ModalInsert";
import { instituicaoAPI } from "../API/instituicaoAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";
import ComboboxMunicipio from "@/modules/city/components/ComboboxMunicipio.vue";

export default {
  components: {
    AppModalInsertUr,
    AppModalDelete,
    ComboboxMunicipio,
  },
  data() {
    return {
      headers: [
        { text: "Instituição", value: "nome" },
        { text: "Responsável", value: "responsavel" },
        { text: "Categoria", value: "categoria" },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
      ],
      payload: [],
      municipios: null,
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadUrs() {
      this.setLoading(true);
      instituicaoAPI
        .list({ municipios: this.municipios })
        .then((resp) => {
          if (
            this.isFullAdmin ||
            (this.config.verTodasInstituicao &&
              this.groupsConfig.verTodasInstituicao)
          ) {
            this.payload = resp.data;
          } else {
            const permissaoUser = this.userTeste.permissoes.map(
              (item) => item.municipioId
            );

            this.payload = resp.data.filter((item) => {
              return item.municipioIds.filter((val) =>
                permissaoUser.includes(val)
              );
            });
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Instituição");
        });
    },
  },
  mounted() {
    this.loadUrs();
  },
  computed: {
    ...mapGetters(["isParceiro", "isSala", "isFullAdmin"]),
  },
};
</script>
